export { default as Terms } from './terms';
